import { render, staticRenderFns } from "./CropitImage.vue?vue&type=template&id=67b241ae&scoped=true&"
import script from "./CropitImage.vue?vue&type=script&lang=ts&"
export * from "./CropitImage.vue?vue&type=script&lang=ts&"
import style0 from "./CropitImage.vue?vue&type=style&index=0&id=67b241ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b241ae",
  null
  
)

export default component.exports